
const ServiceCard = ({ title, description, imageUrl }) => {
  return (
    <div className="group relative aspect-[4/5] w-full overflow-hidden rounded-xl shadow-lg">
      <img
        src={imageUrl}
        alt={title}
        className="absolute inset-0 h-full w-full object-cover transition-all duration-500 ease-in-out group-hover:scale-105 group-hover:brightness-75"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent transition-all duration-500 group-hover:from-black/90 group-hover:via-black/70 group-hover:to-black/20"></div>
      <div className="absolute inset-0 flex flex-col justify-center items-center p-4 text-white md:p-4">
         <h3
            className={`mb-0 text-lg font-semibold transition-transform duration-500 ease-in-out md:text-xl ${
                'group-hover:-translate-y-4'
            }`}>
            {title}
         </h3>
         <p
            className="max-h-0 overflow-hidden text-xs text-gray-300 opacity-0 transition-all duration-500 ease-in-out group-hover:max-h-40 group-hover:opacity-100 md:text-lg">
            {description}
         </p>
      </div>
    </div>
  );
};

export default ServiceCard;